import React, { useState, useEffect } from "react";
import {
    TableHead, Button, Table, TableBody, TableCell, TableContainer, Container, TableRow, Card, TextField
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { GetFantasyPoints, ResetFantasyPoints, ResetUpdateFantasyPoints, UpdateFantasyPoints } from "src/redux/actions/PointsManagementAction";
import { toast } from "react-toastify";
import HeaderBreadcrumbs from "./../../components/HeaderBreadcrumbs";
import Page from "./../../components/Page";
import Loader from "src/components/Loader";
import "./PointsManagement.css"

const FootballPointsManagement = () => {
    const dispatch = useDispatch();
    const StatePoints = useSelector((state) => state?.points?.fantasy_points?.data?.fantasy_data);
    const PointsUpdateMsg = useSelector((state) => state.points.fantasy_points_update_message);
    const loadingSelector = useSelector((state) => state.points.loading);
    const [updatedPointsObj, setUpdatedPointsObj] = useState({})
    const [footballPointsObj, setfootballPointsObj] = useState({
        "points.playfiftyfivemin": 2,
        "points.playsixtyminfwd": 1,
        "points.playsixtyminmid": 1,
        "points.playsixtymindef": 1,
        "points.goalfor": 8,
        "points.goalmid": 9,
        "points.goalgk": 10,
        "points.goaldef": 10,
        "points.assistfow": 0,
        "points.assistmid": 0,
        "points.assistdef": 0,
        "points.assistgk": 0,
        "points.cleansheetfwd": 1,
        "points.cleansheetmid": 1,
        "points.cleansheetgk": 5,
        "points.cleansheetdef": 5,
        "points.penaltysavegk": 9,
        "points.yellowcardgk": 0,
        "points.yellowcardfwd": 0,
        "points.yellowcardmid": 0,
        "points.yellowcarddef": 0,
        "points.redcardgk": 0,
        "points.redcardfwd": 0,
        "points.redcardmid": 0,
        "points.redcarddef": 0,
        "points.owngoaldef": 0,
        "points.owngoalmid": 0,
        "points.owngoalfwd": 0,
        "points.owngoalgk": 0,
        "points.goalsconcededgk": -1,
        "points.penaltymissed": -2,
        "points.shot_on_targetfwd": 2,
        "points.shot_on_targetmid": 2,
        "points.shot_on_targetdef": 2,
        "points.tacklefwd": 0,
        "points.tacklemid": 0,
        "points.tackledef": 0,
        "points.tenpassesgk": 0,
        "points.tenpassesfwd": 0,
        "points.tenpassesmid": 0,
        "points.tenpassesdef": 0,
        "points.goalsaved": 1,
        "points.goalsconcededdef": -1,
        "points.goalsconcededmid": 0,
        "points.goalsconcededfow": 0,
        "points.penaltyscoredfor": 2,
        "points.penaltyscoredmid": 2,
        "points.penaltyscoreddef": 2,
        "points.penaltymisseddef": 0,
        "points.penaltymissedmid": 0,
        "points.penaltymissedfwd": 0,
        "points.foulsdrawndef": 0,
        "points.foulsdrawnmid": 0,
        "points.foulsdrawnfwd": 0,
        "points.interceptionsfwd": 0,
        "points.interceptionsmid": 0,
        "points.interceptionsdef": 0,
        "points.duelswonfwd": 2,
        "points.duelswonmid": 2,
        "points.duelswondef": 2,
        "points.aerials_won": 1,
        "points.punches": 2,
        "points.shot_off_targetfwd": 2,
        "points.shot_off_targetmid": 2,
        "points.shot_off_targetdef": 2,
        "points.chancecreatedfwd": 0,
        "points.chancecreatedmid": 0,
        "points.chancecreateddef": 0,
        "points.threemispassgk": 0,
        "points.threemispassfwd": 0,
        "points.threemispassmid": 0,
        "points.threemispassdef": 0,
        "points.twogoalfwd": 0,
        "points.twogoalmid": 0,
        "points.twogoaldef": 0,
        "points.threegoalfwd": 0,
        "points.threegoalmid": 0,
        "points.threegoaldef": 0,
        "points.playing11": 0,
        "points.dribbles_completedfwd": 0,
        "points.dribbles_completedmid": 0,
        "points.dribbles_completeddef": 0,
        /////////NEW//////////////
        "points.shots_off_target_gk": 0,
        "points.shots_blocked_gk": 0,
        "points.long_passes_gk": 0,
        "points.short_passes_gk": 0,
        "points.challenges_gk": 0,
        "points.yellowcards_gk": 0,
        "points.clearances_gk": 0,
        "points.saves_inside_box_gk": 0,
        "points.dribbled_past_gk": 0,
        "points.penalties_saved_gk": 0,
        "points.rating_gk": 0,
        "points.long_balls_gk": 0,
        "points.long_balls_won_gk": 0,
        "points.matches_gk": 0,
        "points.appearances_gk": 0,
        "points.bench_gk": 0,
        "points.error_lead_to_goal_gk": 0,
        "points.shots_off_target_def": 0,
        "points.offsides_def": 0,
        "points.fouls_def": 0,
        "points.shots_blocked_def": 0,
        "points.long_passes_def": 0,
        "points.short_passes_def": 0,
        "points.hit_woodwork_def": 0,
        "points.successful_headers_def": 0,
        "points.headers_def": 0,
        "points.challenges_def": 0,
        "points.yellowcards_def": 0,
        "points.dispossessed_def": 0,
        "points.offsides_provoked_def": 0,
        "points.total_crosses_def": 0,
        "points.accurate_crosses_def": 0,
        "points.clearances_def": 0,
        "points.total_duels_def": 0,
        "points.aerials_won_def": 0,
        "points.dribbled_past_def": 0,
        "points.penalties_won_def": 0,
        "points.rating_def": 0,
        "points.long_balls_def": 0,
        "points.long_balls_won_def": 0,
        "points.through_balls_def": 0,
        "points.through_balls_won_def": 0,
        "points.matches_def": 0,
        "points.appearances_def": 0,
        "points.bench_def": 0,
        "points.error_lead_to_goal_def": 0,
        "points.shots_off_target_mid": 0,
        "points.offsides_mid": 0,
        "points.fouls_mid": 0,
        "points.shots_blocked_mid": 0,
        "points.long_passes_mid": 0,
        "points.short_passes_mid": 0,
        "points.hit_woodwork_mid": 0,
        "points.successful_headers_mid": 0,
        "points.headers_mid": 0,
        "points.challenges_mid": 0,
        "points.yellowcards_mid": 0,
        "points.dispossessed_mid": 0,
        "points.offsides_provoked_mid": 0,
        "points.total_crosses_mid": 0,
        "points.accurate_crosses_mid": 0,
        "points.clearances_mid": 0,
        "points.total_duels_mid": 0,
        "points.aerials_won_mid": 0,
        "points.dribbled_past_mid": 0,
        "points.penalties_won_mid": 0,
        "points.rating_mid": 0,
        "points.long_balls_mid": 0,
        "points.long_balls_won_mid": 0,
        "points.through_balls_mid": 0,
        "points.through_balls_won_mid": 0,
        "points.matches_mid": 0,
        "points.appearances_mid": 0,
        "points.bench_mid": 0,
        "points.error_lead_to_goal_mid": 0,
        "points.shots_off_target_fwd": 0,
        "points.offsides_fwd": 0,
        "points.fouls_fwd": 0,
        "points.shots_blocked_fwd": 0,
        "points.long_passes_fwd": 0,
        "points.short_passes_fwd": 0,
        "points.hit_woodwork_fwd": 0,
        "points.successful_headers_fwd": 0,
        "points.headers_fwd": 0,
        "points.challenges_fwd": 0,
        "points.yellowcards_fwd": 0,
        "points.dispossessed_fwd": 0,
        "points.total_crosses_fwd": 0,
        "points.accurate_crosses_fwd": 0,
        "points.clearances_fwd": 0,
        "points.total_duels_fwd": 0,
        "points.aerials_won_fwd": 0,
        "points.dribbled_past_fwd": 0,
        "points.penalties_won_fwd": 0,
        "points.rating_fwd": 0,
        "points.long_balls_fwd": 0,
        "points.long_balls_won_fwd": 0,
        "points.through_balls_fwd": 0,
        "points.through_balls_won_fwd": 0,
        "points.matches_fwd": 0,
        "points.appearances_fwd": 0,
        "points.bench_fwd": 0,
        "points.error_lead_to_goal_fwd": 0,
    })

    const footballPointsArray = StatePoints?.length >= 0 && StatePoints.filter((elem) => elem.game_id === 2);

    useEffect(() => {
        dispatch(GetFantasyPoints());
        return () => dispatch(ResetFantasyPoints())
    }, [dispatch]);

    useEffect(() => {
        if (Object.keys(PointsUpdateMsg).length > 0) {
            if (PointsUpdateMsg.data.status) {
                toast.success(PointsUpdateMsg.data.message, { theme: "colored" })
                dispatch(GetFantasyPoints());
                dispatch(ResetUpdateFantasyPoints())
                setUpdatedPointsObj({})
            }
        }
    }, [PointsUpdateMsg])

    const handlePointsChange = (key, value) => {
        footballPointsObj[key] = Number(value);
        setfootballPointsObj(footballPointsObj)
        setUpdatedPointsObj(Object.assign(updatedPointsObj, { [key]: Number(value) }))
    }

    const handleUpdate = () => {
        const sendData = {
            game_id: 2,
            type: "football",
            points: updatedPointsObj
        };
        dispatch(UpdateFantasyPoints(sendData))
    }

    return (
        <Page title="Points Management">
            {loadingSelector ? <Loader /> : null}
            <Container maxWidth="lg">
                <HeaderBreadcrumbs
                    heading="Football Points Management"
                    links={[{ name: "Dashboard", href: "/dashboard/app" },
                    { name: "Football Points Management" }]}
                />
                <Card
                    sx={{ padding: "20px", marginTop: "20px" }}
                    className="points-card-block"
                >
                    {footballPointsArray &&
                        footballPointsArray.map((elem) =>
                            elem.type === "football" ? (
                                <>
                                    <TableContainer>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell> Type of points	 </TableCell>
                                                    <TableCell align="center"> Forward </TableCell>
                                                    <TableCell align="center"> Midfielder </TableCell>
                                                    <TableCell align="center"> Defender </TableCell>
                                                    <TableCell align="center"> GK </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Goal </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.goalfor", target.value)} defaultValue={elem.points["goalfor"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.goalmid", target.value)} defaultValue={elem.points["goalmid"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.goaldef", target.value)} defaultValue={elem.points["goaldef"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.goalgk", target.value)} defaultValue={elem.points["goalgk"]} />
                                                    </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Assist </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.assistfow", target.value)} defaultValue={elem.points["assistfow"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.assistmid", target.value)} defaultValue={elem.points["assistmid"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.assistdef", target.value)} defaultValue={elem.points["assistdef"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.assistgk", target.value)} defaultValue={elem.points["assistgk"]} />
                                                    </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Chance Created </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.chancecreatedfwd", target.value)} defaultValue={elem.points["chancecreatedfwd"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.chancecreatedmid", target.value)} defaultValue={elem.points["chancecreatedmid"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.chancecreateddef", target.value)} defaultValue={elem.points["chancecreateddef"]} />
                                                    </TableCell>
                                                    <TableCell align="center"> NA </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> 4 Passes Completed </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.tenpassesfwd", target.value)} defaultValue={elem.points["tenpassesfwd"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.tenpassesmid", target.value)} defaultValue={elem.points["tenpassesmid"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.tenpassesdef", target.value)} defaultValue={elem.points["tenpassesdef"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.tenpassesgk", target.value)} defaultValue={elem.points["tenpassesgk"]} />
                                                    </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Shot on Target </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.shot_on_targetfwd", target.value)} defaultValue={elem.points["shot_on_targetfwd"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.shot_on_targetmid", target.value)} defaultValue={elem.points["shot_on_targetmid"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.shot_on_targetdef", target.value)} defaultValue={elem.points["shot_on_targetdef"]} />
                                                    </TableCell>
                                                    <TableCell align="center"> NA </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Shot off Target </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.shot_off_targetfwd", target.value)} defaultValue={elem.points["shot_off_targetfwd"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.shot_off_targetmid", target.value)} defaultValue={elem.points["shot_off_targetmid"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.shot_off_targetdef", target.value)} defaultValue={elem.points["shot_off_targetdef"]} />
                                                    </TableCell>
                                                    <TableCell align="center"> NA </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> {"> 60 minutes played"} </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.playsixtyminfwd", target.value)} defaultValue={elem.points["playsixtyminfwd"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.playsixtyminmid", target.value)} defaultValue={elem.points["playsixtyminmid"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.playsixtymindef", target.value)} defaultValue={elem.points["playsixtymindef"]} />
                                                    </TableCell>
                                                    <TableCell align="center"> - </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Appearance (Starting 11 or sub) </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.playing11", target.value)} defaultValue={elem.points["playing11"]} />
                                                    </TableCell>
                                                    <TableCell align="center"> - </TableCell>
                                                    <TableCell align="center"> - </TableCell>
                                                    <TableCell align="center"> - </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> 2 Goal Bonus </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.twogoaldef", target.value)} defaultValue={elem.points["twogoaldef"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.twogoalmid", target.value)} defaultValue={elem.points["twogoalmid"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.twogoalfwd", target.value)} defaultValue={elem.points["twogoalfwd"]} />
                                                    </TableCell>
                                                    <TableCell align="center"> NA </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> 3 Goal Bonus </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.threegoalfwd", target.value)} defaultValue={elem.points["threegoalfwd"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.threegoalmid", target.value)} defaultValue={elem.points["threegoalmid"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.threegoaldef", target.value)} defaultValue={elem.points["threegoaldef"]} />
                                                    </TableCell>
                                                    <TableCell align="center"> NA </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Foul won	 </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.foulsdrawnfwd", target.value)} defaultValue={elem.points["foulsdrawnfwd"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.foulsdrawnmid", target.value)} defaultValue={elem.points["foulsdrawnmid"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.foulsdrawndef", target.value)} defaultValue={elem.points["foulsdrawndef"]} />
                                                    </TableCell>
                                                    <TableCell align="center"> NA </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> 3 Misplaced passes </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.threemispassfwd", target.value)} defaultValue={elem.points["threemispassfwd"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.threemispassmid", target.value)} defaultValue={elem.points["threemispassmid"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.threemispassdef", target.value)} defaultValue={elem.points["threemispassdef"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.threemispassgk", target.value)} defaultValue={elem.points["threemispassgk"]} />
                                                    </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Tackle won </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.tacklefwd", target.value)} defaultValue={elem.points["tacklefwd"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.tacklemid", target.value)} defaultValue={elem.points["tacklemid"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.tackledef", target.value)} defaultValue={elem.points["tackledef"]} />
                                                    </TableCell>
                                                    <TableCell align="center"> NA </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Interception </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.interceptionsfwd", target.value)} defaultValue={elem.points["interceptionsfwd"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.interceptionsmid", target.value)} defaultValue={elem.points["interceptionsmid"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.interceptionsdef", target.value)} defaultValue={elem.points["interceptionsdef"]} />
                                                    </TableCell>
                                                    <TableCell align="center"> NA </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> {`Clean Sheet (Played > 60 min)`} </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.cleansheetfwd", target.value)} defaultValue={elem.points["cleansheetfwd"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.cleansheetmid", target.value)} defaultValue={elem.points["cleansheetmid"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.cleansheetdef", target.value)} defaultValue={elem.points["cleansheetdef"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.cleansheetgk", target.value)} defaultValue={elem.points["cleansheetgk"]} />
                                                    </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Save (GK) </TableCell>
                                                    <TableCell align="center"> NA </TableCell>
                                                    <TableCell align="center"> NA </TableCell>
                                                    <TableCell align="center"> NA </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.goalsaved", target.value)} defaultValue={elem.points["goalsaved"]} />
                                                    </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Penalty Save (GK) </TableCell>
                                                    <TableCell align="center"> NA </TableCell>
                                                    <TableCell align="center"> NA </TableCell>
                                                    <TableCell align="center"> NA </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.penaltysavegk", target.value)} defaultValue={elem.points["penaltysavegk"]} />
                                                    </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Yellow Card </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.yellowcardfwd", target.value)} defaultValue={elem.points["yellowcardfwd"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.yellowcardmid", target.value)} defaultValue={elem.points["yellowcardmid"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.yellowcarddef", target.value)} defaultValue={elem.points["yellowcarddef"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.yellowcardgk", target.value)} defaultValue={elem.points["yellowcardgk"]} />
                                                    </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Red Card </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.redcardfwd", target.value)} defaultValue={elem.points["redcardfwd"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.redcardmid", target.value)} defaultValue={elem.points["redcardmid"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.redcarddef", target.value)} defaultValue={elem.points["redcarddef"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.redcardgk", target.value)} defaultValue={elem.points["redcardgk"]} />
                                                    </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Goal Conceded </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.goalsconcededfow", target.value)} defaultValue={elem.points["goalsconcededfow"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.goalsconcededmid", target.value)} defaultValue={elem.points["goalsconcededmid"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.goalsconcededdef", target.value)} defaultValue={elem.points["goalsconcededdef"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.goalsconcededgk", target.value)} defaultValue={elem.points["goalsconcededgk"]} />
                                                    </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Own Goal </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.owngoalfwd", target.value)} defaultValue={elem.points["owngoalfwd"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.owngoalmid", target.value)} defaultValue={elem.points["owngoalmid"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.owngoaldef", target.value)} defaultValue={elem.points["owngoaldef"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.owngoalgk", target.value)} defaultValue={elem.points["owngoalgk"]} />
                                                    </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Per Foul Conceded </TableCell>
                                                    <TableCell align="center"> - </TableCell>
                                                    <TableCell align="center"> - </TableCell>
                                                    <TableCell align="center"> - </TableCell>
                                                    <TableCell align="center"> - </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Duel Won </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.duelswonfwd", target.value)} defaultValue={elem.points["duelswonfwd"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.duelswonmid", target.value)} defaultValue={elem.points["duelswonmid"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.duelswondef", target.value)} defaultValue={elem.points["duelswondef"]} />
                                                    </TableCell>
                                                    <TableCell align="center"> NA </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Dribbles Completed </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.dribbles_completedfwd", target.value)} defaultValue={elem.points["dribbles_completedfwd"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.dribbles_completedmid", target.value)} defaultValue={elem.points["dribbles_completedmid"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.dribbles_completeddef", target.value)} defaultValue={elem.points["dribbles_completeddef"]} />
                                                    </TableCell>
                                                    <TableCell align="center"> NA </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Penalty Miss </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.penaltymissedfwd", target.value)} defaultValue={elem.points["penaltymissedfwd"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.penaltymissedmid", target.value)} defaultValue={elem.points["penaltymissedmid"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.penaltymisseddef", target.value)} defaultValue={elem.points["penaltymisseddef"]} />
                                                    </TableCell>
                                                    <TableCell align="center"> NA </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Penalty Score </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.penaltyscoredfor", target.value)} defaultValue={elem.points["penaltyscoredfor"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.penaltyscoredmid", target.value)} defaultValue={elem.points["penaltyscoredmid"]} />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.penaltyscoreddef", target.value)} defaultValue={elem.points["penaltyscoreddef"]} />
                                                    </TableCell>
                                                    <TableCell align="center"> NA </TableCell>
                                                </TableRow>

                                                //////////////////////////////
                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Shots Off Target </TableCell>
                                                    {["fwd", "mid", "def","gk"].map(pos => (
                                                        <TableCell align="center">
                                                            <TextField type="number" onChange={({ target }) => handlePointsChange(`points.shots_off_target_${pos}`, target.value)} defaultValue={elem.points[`shots_off_target_${pos}`]} />
                                                        </TableCell>
                                                    ))}
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Shots Blocked </TableCell>
                                                    {["fwd", "mid", "def","gk"].map(pos => (
                                                        <TableCell align="center">
                                                            <TextField type="number" onChange={({ target }) => handlePointsChange(`points.shots_blocked_${pos}`, target.value)} defaultValue={elem.points[`shots_blocked_${pos}`]} />
                                                        </TableCell>
                                                    ))}
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Long Passes </TableCell>
                                                    {["fwd", "mid", "def","gk"].map(pos => (
                                                        <TableCell align="center">
                                                            <TextField type="number" onChange={({ target }) => handlePointsChange(`points.long_passes_${pos}`, target.value)} defaultValue={elem.points[`long_passes_${pos}`]} />
                                                        </TableCell>
                                                    ))}
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Short Passes </TableCell>
                                                    {["fwd", "mid", "def","gk"].map(pos => (
                                                        <TableCell align="center">
                                                            <TextField type="number" onChange={({ target }) => handlePointsChange(`points.short_passes_${pos}`, target.value)} defaultValue={elem.points[`short_passes_${pos}`]} />
                                                        </TableCell>
                                                    ))}
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Challenges </TableCell>
                                                    {["fwd", "mid", "def","gk"].map(pos => (
                                                        <TableCell align="center">
                                                            <TextField type="number" onChange={({ target }) => handlePointsChange(`points.challenges_${pos}`, target.value)} defaultValue={elem.points[`challenges_${pos}`]} />
                                                        </TableCell>
                                                    ))}
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Yellow Cards </TableCell>
                                                    {["fwd", "mid", "def","gk"].map(pos => (
                                                        <TableCell align="center">
                                                            <TextField type="number" onChange={({ target }) => handlePointsChange(`points.yellowcards_${pos}`, target.value)} defaultValue={elem.points[`yellowcards_${pos}`]} />
                                                        </TableCell>
                                                    ))}
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Clearances </TableCell>
                                                    {["fwd", "mid", "def","gk"].map(pos => (
                                                        <TableCell align="center">
                                                            <TextField type="number" onChange={({ target }) => handlePointsChange(`points.clearances_${pos}`, target.value)} defaultValue={elem.points[`clearances_${pos}`]} />
                                                        </TableCell>
                                                    ))}
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Saves Inside Box </TableCell>
                                                    <TableCell align="center">NA</TableCell>
                                                    <TableCell align="center">NA</TableCell>
                                                    <TableCell align="center">NA</TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.saves_inside_box_gk", target.value)} defaultValue={elem.points["saves_inside_box_gk"]} />
                                                    </TableCell>
                                                   
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Dribbled Past </TableCell>
                                                    {["fwd", "mid", "def","gk"].map(pos => (
                                                        <TableCell align="center">
                                                            <TextField type="number" onChange={({ target }) => handlePointsChange(`points.dribbled_past_${pos}`, target.value)} defaultValue={elem.points[`dribbled_past_${pos}`]} />
                                                        </TableCell>
                                                    ))}
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Penalties Saved </TableCell>
                                                    <TableCell align="center">NA</TableCell>
                                                    <TableCell align="center">NA</TableCell>
                                                    <TableCell align="center">NA</TableCell>
                                                    <TableCell align="center">
                                                        <TextField type="number" onChange={({ target }) => handlePointsChange("points.penalties_saved_gk", target.value)} defaultValue={elem.points["penalties_saved_gk"]} />
                                                    </TableCell>
                                                    
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Rating </TableCell>
                                                    {["fwd", "mid", "def","gk"].map(pos => (
                                                        <TableCell align="center">
                                                            <TextField type="number" onChange={({ target }) => handlePointsChange(`points.rating_${pos}`, target.value)} defaultValue={elem.points[`rating_${pos}`]} />
                                                        </TableCell>
                                                    ))}
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Long Balls Won </TableCell>
                                                    {["fwd", "mid", "def","gk"].map(pos => (
                                                        <TableCell align="center">
                                                            <TextField type="number" onChange={({ target }) => handlePointsChange(`points.long_balls_won_${pos}`, target.value)} defaultValue={elem.points[`long_balls_won_${pos}`]} />
                                                        </TableCell>
                                                    ))}
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Long Balls </TableCell>
                                                    {["fwd", "mid", "def","gk"].map(pos => (
                                                        <TableCell align="center">
                                                            <TextField type="number" onChange={({ target }) => handlePointsChange(`points.long_balls_${pos}`, target.value)} defaultValue={elem.points[`long_balls_${pos}`]} />
                                                        </TableCell>
                                                    ))}
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Matches </TableCell>
                                                    {["fwd", "mid", "def","gk"].map(pos => (
                                                        <TableCell align="center">
                                                            <TextField type="number" onChange={({ target }) => handlePointsChange(`points.matches_${pos}`, target.value)} defaultValue={elem.points[`matches_${pos}`]} />
                                                        </TableCell>
                                                    ))}
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Appearances </TableCell>
                                                    {["fwd", "mid", "def","gk"].map(pos => (
                                                        <TableCell align="center">
                                                            <TextField type="number" onChange={({ target }) => handlePointsChange(`points.appearances_${pos}`, target.value)} defaultValue={elem.points[`appearances_${pos}`]} />
                                                        </TableCell>
                                                    ))}
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Bench </TableCell>
                                                    {["fwd", "mid", "def","gk"].map(pos => (
                                                        <TableCell align="center">
                                                            <TextField type="number" onChange={({ target }) => handlePointsChange(`points.bench_${pos}`, target.value)} defaultValue={elem.points[`bench_${pos}`]} />
                                                        </TableCell>
                                                    ))}
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Error Lead to Goal </TableCell>
                                                    {["fwd", "mid", "def","gk"].map(pos => (
                                                        <TableCell align="center">
                                                            <TextField type="number" onChange={({ target }) => handlePointsChange(`points.error_lead_to_goal_${pos}`, target.value)} defaultValue={elem.points[`error_lead_to_goal_${pos}`]} />
                                                        </TableCell>
                                                    ))}
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Offsides Provoked </TableCell>
                                                    <TableCell align="center">NA</TableCell>
                                                    {["def", "mid"].map(pos => (
                                                        <TableCell align="center">
                                                            <TextField type="number" onChange={({ target }) => handlePointsChange(`points.offsides_provoked_${pos}`, target.value)} defaultValue={elem.points[`offsides_provoked_${pos}`]} />
                                                        </TableCell>
                                                    ))}
                                                    <TableCell align="center">NA</TableCell>
                                                   
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Offsides </TableCell>
                                                    {["fwd", "mid","def"].map(pos => (
                                                        <TableCell align="center">
                                                            <TextField type="number" onChange={({ target }) => handlePointsChange(`points.offsides_${pos}`, target.value)} defaultValue={elem.points[`offsides_${pos}`]} />
                                                        </TableCell>
                                                    ))}
                                                    <TableCell align="center">NA</TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Fouls </TableCell>
                                                    {["fwd", "mid","def"].map(pos => (
                                                        <TableCell align="center">
                                                            <TextField type="number" onChange={({ target }) => handlePointsChange(`points.fouls_${pos}`, target.value)} defaultValue={elem.points[`fouls_${pos}`]} />
                                                        </TableCell>
                                                    ))}
                                                    <TableCell align="center">NA</TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Hit Woodwork </TableCell>
                                                    {["fwd", "mid","def"].map(pos => (
                                                        <TableCell align="center">
                                                            <TextField type="number" onChange={({ target }) => handlePointsChange(`points.hit_woodwork_${pos}`, target.value)} defaultValue={elem.points[`hit_woodwork_${pos}`]} />
                                                        </TableCell>
                                                    ))}
                                                    <TableCell align="center">NA</TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Successful Headers </TableCell>
                                                    {["fwd", "mid","def"].map(pos => (
                                                        <TableCell align="center">
                                                            <TextField type="number" onChange={({ target }) => handlePointsChange(`points.successful_headers_${pos}`, target.value)} defaultValue={elem.points[`successful_headers_${pos}`]} />
                                                        </TableCell>
                                                    ))}
                                                    <TableCell align="center">NA</TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Headers </TableCell>
                                                    {["fwd", "mid","def"].map(pos => (
                                                        <TableCell align="center">
                                                            <TextField type="number" onChange={({ target }) => handlePointsChange(`points.headers_${pos}`, target.value)} defaultValue={elem.points[`headers_${pos}`]} />
                                                        </TableCell>
                                                    ))}
                                                    <TableCell align="center">NA</TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Dispossessed </TableCell>
                                                    {["fwd", "mid","def"].map(pos => (
                                                        <TableCell align="center">
                                                            <TextField type="number" onChange={({ target }) => handlePointsChange(`points.dispossessed_${pos}`, target.value)} defaultValue={elem.points[`dispossessed_${pos}`]} />
                                                        </TableCell>
                                                    ))}
                                                    <TableCell align="center">NA</TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Total Crosses </TableCell>
                                                    {["fwd", "mid","def"].map(pos => (
                                                        <TableCell align="center">
                                                            <TextField type="number" onChange={({ target }) => handlePointsChange(`points.total_crosses_${pos}`, target.value)} defaultValue={elem.points[`total_crosses_${pos}`]} />
                                                        </TableCell>
                                                    ))}
                                                    <TableCell align="center">NA</TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Accurate Crosses </TableCell>
                                                    {["fwd", "mid","def"].map(pos => (
                                                        <TableCell align="center">
                                                            <TextField type="number" onChange={({ target }) => handlePointsChange(`points.accurate_crosses_${pos}`, target.value)} defaultValue={elem.points[`accurate_crosses_${pos}`]} />
                                                        </TableCell>
                                                    ))}
                                                    <TableCell align="center">NA</TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Total Duels </TableCell>
                                                    {["fwd", "mid","def"].map(pos => (
                                                        <TableCell align="center">
                                                            <TextField type="number" onChange={({ target }) => handlePointsChange(`points.total_duels_${pos}`, target.value)} defaultValue={elem.points[`total_duels_${pos}`]} />
                                                        </TableCell>
                                                    ))}
                                                    <TableCell align="center">NA</TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Aerials Won </TableCell>
                                                    {["fwd", "mid","def"].map(pos => (
                                                        <TableCell align="center">
                                                            <TextField type="number" onChange={({ target }) => handlePointsChange(`points.aerials_won_${pos}`, target.value)} defaultValue={elem.points[`aerials_won_${pos}`]} />
                                                        </TableCell>
                                                    ))}
                                                    <TableCell align="center">NA</TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Penalties Won </TableCell>
                                                    {["fwd", "mid","def"].map(pos => (
                                                        <TableCell align="center">
                                                            <TextField type="number" onChange={({ target }) => handlePointsChange(`points.penalties_won_${pos}`, target.value)} defaultValue={elem.points[`penalties_won_${pos}`]} />
                                                        </TableCell>
                                                    ))}
                                                    <TableCell align="center">NA</TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Through Balls Won </TableCell>
                                                    {["fwd", "mid","def"].map(pos => (
                                                        <TableCell align="center">
                                                            <TextField type="number" onChange={({ target }) => handlePointsChange(`points.through_balls_won_${pos}`, target.value)} defaultValue={elem.points[`through_balls_won_${pos}`]} />
                                                        </TableCell>
                                                    ))}
                                                    <TableCell align="center">NA</TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell component="th" scope="row"> Through Balls </TableCell>
                                                    {["fwd", "mid","def"].map(pos => (
                                                        <TableCell align="center">
                                                            <TextField type="number" onChange={({ target }) => handlePointsChange(`points.through_balls_${pos}`, target.value)} defaultValue={elem.points[`through_balls_${pos}`]} />
                                                        </TableCell>
                                                    ))}
                                                    <TableCell align="center">NA</TableCell>
                                                </TableRow>

                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                    <br />
                                    <div align="right">
                                        <Button
                                            onClick={handleUpdate}
                                            variant="contained"
                                            color="primary"
                                            size="large"
                                        >
                                            Update
                                        </Button>
                                    </div>
                                </>
                            ) : (
                                ""
                            ),
                        )}
                </Card>
            </Container>
        </Page>
    );
};

export default FootballPointsManagement;
